import { styled } from '../../ui/styled-components';

export const SearchInputContainer = styled.div`
  position: relative;
`;
